import React from 'react';
import Select from 'react-select';

const MappingPanel = ({ fields, headers, mapping, defaults, onChange, onDefaultChange }) => {
  const options = [
    { value: '', label: '-- not mapped --' },
    ...headers.map((header) => ({ value: header, label: header })),
  ];

  return (
    <section className="widget full-width form-table">
      <header>
        <h3>Map columns</h3>
        <div className="actions">
          <span className="migration-hint">
            Columns are detected automatically. Correct anything that was
            matched to the wrong field.
          </span>
        </div>
      </header>
      <main>
        <div className="form-content">
          <table>
            <thead>
              <tr>
                <th>Petrometer field</th>
                <th>Excel column</th>
                <th>Value to use when the column is missing</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field) => (
                <tr key={field.key}>
                  <td>
                    {field.label}
                    {field.required && <span className="vn-red"> *</span>}
                    {field.note && (
                      <div className="migration-hint">{field.note}</div>
                    )}
                  </td>
                  <td>
                    <div className="input-wrapper">
                      <Select
                        options={options}
                        className="select-box-container"
                        classNamePrefix="column-selector"
                        placeholder="Select column"
                        value={options.filter(
                          ({ value }) => value === (mapping[field.key] || ''),
                        )}
                        onChange={(option) =>
                          onChange(field.key, option ? option.value : '')
                        }
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </td>
                  <td>
                    {field.allowDefault && !mapping[field.key] ? (
                      <div className="input-wrapper">
                        <input
                          type="text"
                          name={field.key}
                          value={defaults[field.key] || ''}
                          placeholder={
                            field.type === 'date' ? 'YYYY-MM-DD' : 'Value'
                          }
                          onChange={(e) =>
                            onDefaultChange(field.key, e.target.value)
                          }
                        />
                      </div>
                    ) : (
                      <span className="migration-hint">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </section>
  );
};

export { MappingPanel };
